import ZlbConfirm from '@/components/ZlbConfirm';
import { message } from 'doraemon';
import {
  reqList,
  pagingPositions,
  getUserCategoryList,
  deletePositionManager,
  positionManagerTenantUpdate,
  positionManagerTenantAllocation,
} from '../services';

/**
 * 请求错误信息统一处理
 * @param msg
 */
const responseErrorHandle = (msg) => {
  message.destroy();
  ZlbConfirm({
    title: '错误',
    content: msg,
    showOkBtn: false,
    cancelText: '知道了',
  });
};

export default {
  namespace: 'privilegeAllocation',
  state: {
    info: {},
    list: {},
    tenantList: [],
    pageNo: 1,
    pageSize: 1000,
    userCategory: [],
    roleTreeData: [],
    userCategoryList: [],
    pagingPositionsDate: {},
    pagingAllPositionsDate: [],
  },
  effects: {
    * fetchInfo (payload, { call, put }) {
      const res = yield call(reqList, payload);
      if (res.success) {
        yield put({
          type: 'update',
          payload: {
            list: res.result,
            pageNo: payload.pageNo,
          },
        });
      } else {
        responseErrorHandle(res.message || res.error);
      }
      return res;
    },

    * getAllTenant (payload, { call, put }) {
      const res = yield call(reqList, {
        pageSize: 1000,
        pageNo: 1,
        id: payload.id,
      });
      if (res.success) {
        yield put({
          type: 'update',
          payload: {
            tenantList: res.result.data,
          },
        });
      } else {
        responseErrorHandle(res.message || res.error);
      }
      return res;
    },

    * positionManagerTenantUpdate (params, { call }) {
      const res = yield call(positionManagerTenantUpdate, params);
      if (!res.success) {
        responseErrorHandle(res.message || res.error);
      }
      return res;
    },

    * positionManagerTenantAllocation ({ params }, { call }) {
      const res = yield call(positionManagerTenantAllocation, params);
      if (!res.success) {
        responseErrorHandle(res.message || res.error);
      }
      return res;
    },

    * deletePositionManager (params, { call }) {
      const res = yield call(deletePositionManager, params);
      if (!res.success) {
        responseErrorHandle(res.message || res.error);
      }
      return res;
    },
    
    * pagingPositions ({ params }, { call, put }) {
      const res = yield call(pagingPositions, params);
      if (res.success) {
        res.result.data = res.result.data?.map((item) => { item.key = item.id; return item });
        yield put({
          type: 'update',
          payload: {
            pagingPositionsDate: res.result,
          },
        });
      }
      return res;
    },

    * pagingAllPositions ({ params }, { call, put }) {
      const res = yield call(pagingPositions, { ...params });
      if (res.success) {
        // res.result.data = res.result.data?.map((item) => { item.key = item.id; return item; });
        yield put({
          type: 'update',
          payload: {
            pagingAllPositionsDate: res.result.data,
          },
        });
      }
      return res;
    },

    * getUserCategoryList ({ params }, { call, put }) {
      const res = yield call(getUserCategoryList, params);
      if (res.success) {
        yield put({
          type: 'update',
          payload: {
            userCategoryList: res.result,
          },
        });
      }
      return res;
    },
    
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
